module.exports = __webpack_public_path__ + "static/media/coronacell.2ecae029.png";